module.exports = __webpack_public_path__ + "media/images/home/getlisted-bg-new-74153b566245250fcf35e5c17af639d2.jpg";